














import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { isEqual, uniqWith } from 'lodash-es';
import { MappedAggregation } from '~/features/facets';
import { AggregationOption } from '~/graphql-types.gen';
import { toNonNullable } from '~/utils/collections';

function arrayToAggregationOption(array: number[]): string {
  return `${array[0]}-${array[1]}`;
}
const facetTypeComponentMapper = {
  price: 'FacetTagPrice',
  select: 'FacetTagSelect',
};

export default defineComponent({
  /**
   * @description responsible for wrapping the facets object and render the selected facets based on the values selected
   */
  name: 'FacetsTagsList',
  props: {
    facets: {
      type: Array as PropType<MappedAggregation[]>,
      required: false,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const selectedFacets = computed(() => {
      return props.facets.reduce<Array<AggregationOption>>((allSelectedFacets, facet) => {
        const newValues = uniqWith(
          toNonNullable(Array.isArray(facet.value) ? facet.value : [facet.value]).map(v => ({
            ...v,
            type: facet.type,
            code: facet.code,
            label: facet.type === 'price' ? 'Price' : v.label,
            value: facet.type === 'price' ? resolvePriceValue(facet) : v.value,
          })),
          function (a, b) {
            return a.code === b.code && a.value === b.value;
          }
        ).filter(v => !!v.value);

        return [...allSelectedFacets, ...(newValues ?? [])];
      }, []);
    });

    function resolvePriceValue(facet: MappedAggregation) {
      if (isEqual(facet.value, facet.options)) return '';
      return arrayToAggregationOption((facet.value as unknown) as number[]);
    }

    function handleOnSelectItem(e: AggregationOption & { type: string }) {
      if (e.type === 'price') {
        emit('click', e);
        return;
      }

      emit('click', e);
    }

    return { selectedFacets, facetTypeComponentMapper, handleOnSelectItem };
  },
});
